/**
 * A number the way the reader's own language writes it: the thousands set
 * apart by whatever their browser's locale sets them apart with, so
 * experience reads 1,234,567 in English, 1.234.567 in German and
 * 1 234 567 in French (2026-10-13: "add i18n aware thousands separators to
 * number values such as exp"). The locale is the browser's own — nobody
 * picks it in the game — and the format is made once, since a fresh
 * Intl.NumberFormat on every redraw of the stats panel is a cost for
 * nothing.
 *
 * It is for numbers a person reads: experience, health and mana, gold and
 * prices, counts. Not for numbers that go back into anything — a quantity
 * box's value, a CSS width, a cache key — where a comma is a syntax error
 * rather than a kindness. What the server writes into the log is the
 * server's and stays as it sends it.
 */
const fmt = new Intl.NumberFormat();

export function num(n: number): string {
  return fmt.format(n);
}
